/**
 * @sumary Contantes para tipos de registradores.
 */

/**
 * @summary Registrador utilzado para registro de atuação da lubrificação do Pitch (Full Course)
 */
const FULL_COURSE = 1;

/**
 * @summary Registrador utilizado para registros da máquina em operação.
 */
const OPERATING = 2;

export default {
	FULL_COURSE,
	OPERATING,
};